import { useEffect, useState } from 'react'

import { env } from 'src/config/env'
import IosImage from 'src/shared/assets/images/app-store.png'
import { Button } from 'src/shared/components/ui/buttons/button'
import { ResponsivePopup } from 'src/shared/components/ui/popups/responsive-popup'

const IOS_POPUP_DISMISSED = 'ios_popup_dismissed'

export const IOSDownloadPopup = () => {
  const [open, setOpen] = useState(false)

  const handleExternalLink = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  useEffect(() => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
    const hasSeenPopup = localStorage.getItem(IOS_POPUP_DISMISSED)

    if (isIOS && !hasSeenPopup) {
      setOpen(true)
    }
  }, [])

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      localStorage.setItem(IOS_POPUP_DISMISSED, 'true')
    }
    setOpen(isOpen)
  }

  if (!open) return null

  return (
    <ResponsivePopup trigger={<div />} title="The iOS App is here" dark open={open} onOpenChange={handleOpenChange}>
      <div className="flex flex-col items-center space-y-10">
        <img src={IosImage} alt="Download on the App Store" className="w-64" />
        <p className="text-center text-primary-foreground/90">
          Take your referral network mobile. Download now to stay connected on the go.
        </p>
        <Button variant="secondaryInverse" onClick={() => handleExternalLink(env.IOS_APP_URL)} className="w-full">
          Download now
        </Button>
      </div>
    </ResponsivePopup>
  )
}
